import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { LoadScript } from "@react-google-maps/api";
import { CssBaseline } from "@material-ui/core";
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { transitions, positions, Provider as AlertProvider } from 'react-alert'
// import AlertTemplate from 'react-alert-template-mui'
import AlertTemplate from './components/AlertTemplate'
import config from './config';
import { ConfirmProvider } from "material-ui-confirm";
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';

const theme = createMuiTheme({
    palette: {
        primary: {
            main: '#0097a7',
        },
        secondary: {
            main: '#666666',
        },
    },
});

const options = {
    position: positions.BOTTOM_CENTER,
    timeout: 5000,
    offset: '30px',
    transition: transitions.SCALE
}

ReactDOM.render(
    <ThemeProvider theme={theme}>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <LoadScript googleMapsApiKey={config.GOOGLE_MAPS_API_KEY}>
                <AlertProvider template={AlertTemplate} {...options}>
                    <ConfirmProvider>
                        <CssBaseline />
                        <App />
                    </ConfirmProvider>
                </AlertProvider>
            </LoadScript>
        </MuiPickersUtilsProvider>
    </ThemeProvider>,
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
